import confetti from '../assets/confetti_voucher.png';
import check_mark_yellow from '../assets/check_mark_yellow.png';
import error_mark_red from '../assets/error.png';
import { useState, useEffect } from 'react';

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        // Cookie like "csrftoken=<value>"
        if (cookie.substring(0, name.length + 1) === (name + "=")) {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
            break;
        }
        }
    }
    return cookieValue;
}

export default function Redeem(props) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.target;
        const newErrors = {};
        
        // Check required fields
        const requiredFields = [
          'reference-number',
          'first-name', 
          'last-name', 
          'email', 
        ];
        
        requiredFields.forEach(field => {
          if (!form[field].value.trim()) {
            newErrors[field] = 'required';
          }
        });
        
        // Check email format
        if (form['email'].value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form['email'].value)) {
          newErrors['email'] = 'not a valid email address';
        }
    
        setErrors(newErrors);
    
        // If no errors, submit the form and show payment form
        if (Object.keys(newErrors).length === 0) {
          try {
            // Create gift object
            const redeemData = {
              first_name: form['first-name'].value,
              last_name: form['last-name'].value,
              email: form['email'].value,
              reference_number: form['reference-number'].value,
            };
    
            console.log(redeemData);
    
            const csrfToken = getCookie('csrftoken');
    
            // Send to your API
            const response = await fetch('/api/redeem_gift', {
              method: 'POST',
              credentials: 'include',  // Important for cookies
              headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
              },
              body: JSON.stringify(redeemData),
            });
            
            const redeemResponse = await response.json();
            console.log(redeemResponse);
            if (redeemResponse.success) {
                setSuccess(true);
            } else {
                setErrorMessage(redeemResponse.error);
            }
          } catch (error) {
            console.error('Error:', error);
            setErrorMessage('An error occurred while redeeming your gift. Please try again later.');
          }
        } else {
          setErrors(newErrors);
        }
    };

    function dismissModal() {
        setSuccess(false);
        setErrorMessage('');
    }

    function getSuccessBox() {
        return (
            <div className="opaque-overlay">
                <div className="success-box">
                    <img src={check_mark_yellow} className="success-box-check-mark"/>
                    <h2 className="success-box-title">Gift Successfully Redeemed!</h2>
                    <p className="success-box-subtitle">
                        Nice! You've successfully redeemed your gift. Check your email for next steps.
                    </p>
                    <button className="success-box-button" onClick={props.goHome}>Go Back Home</button>
                </div>
            </div>
        )
    }

    function getErrorBox() {
        return (
            <div className="opaque-overlay" onClick={dismissModal}>
                <div className="error-box">
                    <button className="modal-close-button" onClick={dismissModal}>X</button>
                    <img src={error_mark_red} className="error-box-check-mark"/>
                    <h2 className="error-box-title">Something went wrong!</h2>
                    <p className="error-box-subtitle">
                        {errorMessage}
                    </p>
                </div>
            </div>
        )
    }

    return (
        <div className="redeem-container">
            <img
                src={confetti}
                alt="confetti"
                className="redeem-confetti"
            />
            <h1 className="redeem-title">Woohoo, you got a gift!</h1>
            <div className="redeem-subtitle-container">
                <h2 className="redeem-subtitle">
                    Living Legend will help you put your life stories onto the page. We'll interview you over 
                    Zoom for an hour and then ghostwrite a chapter in your autobiography. You'll get two 
                    printed hardcover booklets, a digital copy that's easy to share, and even an audio version 
                    that you can listen to.
                </h2>
            </div>
            <div className="redeem-living-legend-summary-container">
                {success? getSuccessBox() : <></> }
                {errorMessage != '' ? getErrorBox() : <></> }
                <h1 className="redeem-title">Redeem Your Gift</h1>
                <h2 className="redeem-subtitle">
                    We just need a few details to get started.
                </h2>
                <form className="redeem-form" noValidate onSubmit={handleSubmit}>
                    <div className="redeem-form-row">
                        <div className="redeem-form-group">
                            <label htmlFor="reference-number">
                                Reference Number {errors['reference-number'] && <span className="error-text">({errors['reference-number']})</span>}
                            </label>
                            <input 
                                type="text" 
                                placeholder="Reference Number" 
                                defaultValue={props.referenceNumber}
                                name="reference-number"
                            />
                        </div>
                    </div>
                    <div className="redeem-form-row">
                        <div className="redeem-form-group">
                            <label htmlFor="first-name">
                                First Name {errors['first-name'] && <span className="error-text">({errors['first-name']})</span>}
                            </label>
                            <input 
                                type="text" 
                                placeholder="First Name" 
                                name="first-name"
                            />
                        </div>
                        <div className="redeem-form-group">
                            <label htmlFor="last-name">
                                Last Name {errors['last-name'] && <span className="error-text">({errors['last-name']})</span>}
                            </label>
                            <input 
                                type="text" 
                                placeholder="Last Name" 
                                name="last-name"
                            />
                        </div>
                    </div>
                    <div className="redeem-form-row">
                        <div className="redeem-form-group">
                            <label htmlFor="email">
                                Email {errors['email'] && <span className="error-text">({errors['email']})</span>}
                            </label>
                            <input 
                                type="email" 
                                placeholder="Email" 
                                name="email"
                            />
                        </div>
                    </div>
                    <button type="submit" className="redeem-form-button">Redeem</button>
                </form>
            </div>
            
        </div>
    )
}